import { Component, OnInit, OnDestroy } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { finalize, takeUntil } from 'rxjs/operators'
import { Observable, Subject } from 'rxjs'

import { AuthService } from '../auth.service'
import { handleFormErrors } from '@core/helpers/handle-form-errors'
import { PlatformSettings } from '@shared/models/platform-settings.model'
import { PlatformSettingsService } from '@core/services/platfrom-settings.service'

@Component({
  selector: 'lin-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false,
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  resetForm: FormGroup
  formError: string
  isMessageShown = true
  isSubmitting = false
  platformSettings$: Observable<PlatformSettings>

  private readonly onDestroy$ = new Subject<void>()

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private readonly platformSettingsService: PlatformSettingsService,
  ) {}

  ngOnInit(): void {
    this.initForm()

    this.platformSettings$ = this.platformSettingsService.platformSettings$
  }

  private initForm(): void {
    this.resetForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    })

    this.resetForm.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(() => (this.formError = ''))
  }

  resetPassword(): void {
    this.isSubmitting = true

    this.authService
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
      .requestNewPassword(this.resetForm.value.email)
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.isSubmitting = true)),
      )
      .subscribe(
        () => (this.isMessageShown = false),
        (error) => (this.formError = handleFormErrors(this.resetForm)(error)),
      )
  }

  ngOnDestroy(): void {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
